
    import { subscribeToAuth } from "./src/services/auth.js";

    document.addEventListener("DOMContentLoaded", () => {
      subscribeToAuth((user) => {
        const ctaBtns = document.querySelectorAll(".cta-enroll");
        if (user) {
          ctaBtns.forEach(btn => {
            btn.innerText = "Ir para o Painel do Aluno";
            btn.setAttribute("href", "./painel-aluno.html");
          });
        } else {
          ctaBtns.forEach(btn => {
            btn.innerText = "Matricular-se / Começar Agora";
            btn.setAttribute("href", "./index.html?action=register");
          });
        }
      });
    });
  